"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("../../common/Checkbox"));

require("./style.css");

var _excluded = ["children", "style"],
    _excluded2 = ["children", "className"],
    _excluded3 = ["children", "stretch", "style"],
    _excluded4 = ["children"],
    _excluded5 = ["children", "className"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children", "isSentimentAnalyzerOn"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"],
    _excluded26 = ["children"],
    _excluded27 = ["children"],
    _excluded28 = ["children"],
    _excluded29 = ["children"],
    _excluded30 = ["children"],
    _excluded31 = ["children"],
    _excluded32 = ["children"],
    _excluded33 = ["children"],
    _excluded34 = ["children"],
    _excluded35 = ["children"],
    _excluded36 = ["children"],
    _excluded37 = ["children"],
    _excluded38 = ["children"],
    _excluded39 = ["children"],
    _excluded40 = ["children"],
    _excluded41 = ["children"],
    _excluded42 = ["children"],
    _excluded43 = ["children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["children"],
    _excluded47 = ["children"],
    _excluded48 = ["children", "active"],
    _excluded49 = ["children"],
    _excluded50 = ["children", "isChatTextMedia"],
    _excluded51 = ["children"],
    _excluded52 = ["children"],
    _excluded53 = ["children", "className"],
    _excluded54 = ["children"],
    _excluded55 = ["children"],
    _excluded56 = ["children"],
    _excluded57 = ["children"],
    _excluded58 = ["children"],
    _excluded59 = ["children"],
    _excluded60 = ["children", "className"],
    _excluded61 = ["children"],
    _excluded62 = ["children"],
    _excluded63 = ["children"],
    _excluded64 = ["children"],
    _excluded65 = ["children"],
    _excluded66 = ["children"],
    _excluded67 = ["children"],
    _excluded68 = ["children"],
    _excluded69 = ["children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["children"],
    _excluded73 = ["children"],
    _excluded74 = ["children"],
    _excluded75 = ["children", "collapsed"],
    _excluded76 = ["children"],
    _excluded77 = ["children"],
    _excluded78 = ["children"],
    _excluded79 = ["children"],
    _excluded80 = ["children"],
    _excluded81 = ["children"],
    _excluded82 = ["children"],
    _excluded83 = ["children"],
    _excluded84 = ["children"],
    _excluded85 = ["children"],
    _excluded86 = ["children"],
    _excluded87 = ["children"],
    _excluded88 = ["children"],
    _excluded89 = ["children"],
    _excluded90 = ["children"],
    _excluded91 = ["children"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["children"],
    _excluded95 = ["children"],
    _excluded96 = ["children"],
    _excluded97 = ["children"],
    _excluded98 = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var S = {}; // ---------------------------
// General
// ---------------------------

S.Grid = function (_ref) {
  var children = _ref.children,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "grid"
  }, rest), children);
};

S.GridRow = function (_ref2) {
  var children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? "" : _ref2$className,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "grid-row " + className,
    style: {
      height: rest.stretch ? "100%" : "auto",
      flex: rest.stretch ? "auto" : "none"
    }
  }, rest), children);
};

S.GridCell = function (_ref3) {
  var children = _ref3.children,
      stretch = _ref3.stretch,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "grid-cell",
    style: _extends({
      flex: stretch ? "1" : "none"
    }, style)
  }, rest), children);
};

S.PanelStack = function (_ref4) {
  var children = _ref4.children,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded4);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "panel-stack"
  }, rest), children);
};

S.PanelStackHeader = function (_ref5) {
  var children = _ref5.children,
      _ref5$className = _ref5.className,
      className = _ref5$className === void 0 ? "" : _ref5$className,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded5);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "panel-stack-header " + className
  }, rest), children);
}; // S.PanelStackButton = styled.button`
//   border: none;
//   border-radius: 4px 4px 0 0;
//   height: 100%;
//   box-sizing: border-box;
//   vertical-align: middle;
//   border: ${props => props.active ? '1px rgb(220, 220, 220) solid' : '1px transparent solid'};
//   border-bottom: none;
//   font-size: 12px;
//   font-weight: 500;
//   position: relative;
//   background: ${props => props.active ? 'rgb(255, 255, 255)' : 'none'};
//   z-index: ${props => props.active ? '4' : '0'};
//   cursor: pointer;
//   :after {
//     position: absolute;
//     content: '';
//     bottom: -1px;
//     height: 1px;
//     left: 0;
//     width: 100%;
//     background: rgb(255, 255, 255);
//     display: ${props => props.active ? 'block' : 'none'}
//   }
//   :focus {
//     outline:0;
//   }
// `;


S.PanelStackButton = function (_ref6) {
  var children = _ref6.children,
      rest = _objectWithoutPropertiesLoose(_ref6, _excluded6);

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    className: "panel-stack-button",
    style: {
      border: rest.active ? "1px rgb(161, 161, 161) solid" : "1px rgb(238, 238, 238) solid",
      background: rest.active ? "rgb(255, 255, 255)" : "none",
      zIndex: rest.active ? "4" : "0",
      color: rest.active ? "black" : "rgb(103, 119, 145)",
      fontSize: "11px"
    }
  }, rest), children);
};

S.Panel = function (_ref7) {
  var children = _ref7.children,
      rest = _objectWithoutPropertiesLoose(_ref7, _excluded7);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "panel"
  }, rest), children);
};

S.PanelHeader = function (_ref8) {
  var children = _ref8.children,
      rest = _objectWithoutPropertiesLoose(_ref8, _excluded8);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "panel-header"
  }, rest), children);
};

S.PanelBody = function (_ref9) {
  var children = _ref9.children,
      rest = _objectWithoutPropertiesLoose(_ref9, _excluded9);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "panel-body"
  }, rest), children);
};

S.PanelFooter = function (_ref10) {
  var children = _ref10.children,
      rest = _objectWithoutPropertiesLoose(_ref10, _excluded10);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "panel-footer"
  }, rest), children);
};

S.Header = function (_ref11) {
  var children = _ref11.children,
      rest = _objectWithoutPropertiesLoose(_ref11, _excluded11);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "header"
  }, rest), children);
}; //
//
//


S.PlayerHeader = function (_ref12) {
  var children = _ref12.children,
      rest = _objectWithoutPropertiesLoose(_ref12, _excluded12);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "player-header"
  }, rest), children);
}; // ---------------------------
// CategoryTable
// ---------------------------


S.Categories = function (_ref13) {
  var children = _ref13.children,
      rest = _objectWithoutPropertiesLoose(_ref13, _excluded13);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "categories"
  }, rest), children);
};

S.CategoriesTable = function (_ref14) {
  var children = _ref14.children,
      rest = _objectWithoutPropertiesLoose(_ref14, _excluded14);

  return /*#__PURE__*/_react["default"].createElement("table", _extends({
    className: "categories-table"
  }, rest), children);
}; // ---------------------------
// Field
// ---------------------------


S.Fields = function (_ref15) {
  var children = _ref15.children,
      rest = _objectWithoutPropertiesLoose(_ref15, _excluded15);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "fields"
  }, rest), children);
};

S.Field = function (_ref16) {
  var children = _ref16.children,
      rest = _objectWithoutPropertiesLoose(_ref16, _excluded16);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "field"
  }, rest), children);
};

S.FieldTitle = function (_ref17) {
  var children = _ref17.children,
      rest = _objectWithoutPropertiesLoose(_ref17, _excluded17);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "field-title"
  }, rest), children);
};

S.FieldBadge = function (_ref18) {
  var children = _ref18.children,
      rest = _objectWithoutPropertiesLoose(_ref18, _excluded18);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "field-badge"
  }, rest), children);
};

S.FieldValue = function (_ref19) {
  var children = _ref19.children,
      rest = _objectWithoutPropertiesLoose(_ref19, _excluded19);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "field-value"
  }, rest), children);
}; // ---------------------------
// Timeline
// ---------------------------


S.Timeline = function (_ref20) {
  var children = _ref20.children,
      rest = _objectWithoutPropertiesLoose(_ref20, _excluded20);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "timeline"
  }, rest), children);
};

S.TimelineBody = function (_ref21) {
  var children = _ref21.children,
      rest = _objectWithoutPropertiesLoose(_ref21, _excluded21);

  return /*#__PURE__*/_react["default"].createElement("table", _extends({
    className: "timeline-body"
  }, rest), children);
};

S.TimelinePlayhead = function (_ref22) {
  var children = _ref22.children,
      isSentimentAnalyzerOn = _ref22.isSentimentAnalyzerOn,
      rest = _objectWithoutPropertiesLoose(_ref22, _excluded22);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: "timeline-play-head",
    style: {
      pointerEvents: isSentimentAnalyzerOn ? "none" : "visible",
      cursor: isSentimentAnalyzerOn ? "auto" : "pointer"
    }
  }, rest), children);
};

S.TrackGroup = function (_ref23) {
  var children = _ref23.children,
      rest = _objectWithoutPropertiesLoose(_ref23, _excluded23);

  return /*#__PURE__*/_react["default"].createElement("tbody", _extends({
    className: "track-group"
  }, rest), children);
};

S.TrackGroupLabel = function (_ref24) {
  var children = _ref24.children,
      rest = _objectWithoutPropertiesLoose(_ref24, _excluded24);

  return /*#__PURE__*/_react["default"].createElement("th", _extends({
    className: "track-group"
  }, rest), children);
};

S.Track = function (_ref25) {
  var children = _ref25.children,
      rest = _objectWithoutPropertiesLoose(_ref25, _excluded25);

  return /*#__PURE__*/_react["default"].createElement("tr", _extends({
    className: "track"
  }, rest), children);
};

S.TrackLabel = function (_ref26) {
  var children = _ref26.children,
      rest = _objectWithoutPropertiesLoose(_ref26, _excluded26);

  return /*#__PURE__*/_react["default"].createElement("td", _extends({
    className: "track-label"
  }, rest), children);
};

S.TrackContent = function (_ref27) {
  var children = _ref27.children,
      rest = _objectWithoutPropertiesLoose(_ref27, _excluded27);

  return /*#__PURE__*/_react["default"].createElement("td", _extends({
    className: "track-content"
  }, rest), children);
}; // ---------------------------
// Controls
// ---------------------------


S.Controls = function (_ref28) {
  var children = _ref28.children,
      rest = _objectWithoutPropertiesLoose(_ref28, _excluded28);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "control"
  }, rest), children);
};

S.ControlsHeader = function (_ref29) {
  var children = _ref29.children,
      rest = _objectWithoutPropertiesLoose(_ref29, _excluded29);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "control-header"
  }, rest), children);
};

S.ControlsBar = function (_ref30) {
  var children = _ref30.children,
      rest = _objectWithoutPropertiesLoose(_ref30, _excluded30);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "control-bar"
  }, rest), children);
};

S.ControlsGroup = function (_ref31) {
  var children = _ref31.children,
      rest = _objectWithoutPropertiesLoose(_ref31, _excluded31);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "control-group"
  }, rest), children);
};

S.PrimaryControls = function (_ref32) {
  var children = _ref32.children,
      rest = _objectWithoutPropertiesLoose(_ref32, _excluded32);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "primary-control"
  }, rest), children);
};

S.VolumeControls = function (_ref33) {
  var children = _ref33.children,
      rest = _objectWithoutPropertiesLoose(_ref33, _excluded33);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "volume-control"
  }, rest), children);
};

S.MoreDetailTooltipContent = function (_ref34) {
  var children = _ref34.children,
      rest = _objectWithoutPropertiesLoose(_ref34, _excluded34);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "more-detail-tooltip-content"
  }, rest), children);
}; // ---------------------------
// Progress
// ---------------------------


S.Progress = function (_ref35) {
  var children = _ref35.children,
      rest = _objectWithoutPropertiesLoose(_ref35, _excluded35);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress"
  }, rest), children);
};

S.ProgressSlider = function (_ref36) {
  var children = _ref36.children,
      rest = _objectWithoutPropertiesLoose(_ref36, _excluded36);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-slider"
  }, rest), children);
};

S.ProgressTime = function (_ref37) {
  var children = _ref37.children,
      rest = _objectWithoutPropertiesLoose(_ref37, _excluded37);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-time"
  }, rest), children);
};

S.ProgressMark = function (_ref38) {
  var children = _ref38.children,
      rest = _objectWithoutPropertiesLoose(_ref38, _excluded38);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-mask"
  }, rest), children);
};

S.ProgressContent = function (_ref39) {
  var children = _ref39.children,
      rest = _objectWithoutPropertiesLoose(_ref39, _excluded39);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-content"
  }, rest), children);
};

S.ProgressHeader = function (_ref40) {
  var children = _ref40.children,
      rest = _objectWithoutPropertiesLoose(_ref40, _excluded40);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-header"
  }, rest), children);
};

S.ProgressLabel = function (_ref41) {
  var children = _ref41.children,
      rest = _objectWithoutPropertiesLoose(_ref41, _excluded41);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-label"
  }, rest), children);
};

S.ProgressEventMark = function (_ref42) {
  var children = _ref42.children,
      rest = _objectWithoutPropertiesLoose(_ref42, _excluded42);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-label-mark"
  }, rest), children);
};

S.ProgressControl = function (_ref43) {
  var children = _ref43.children,
      rest = _objectWithoutPropertiesLoose(_ref43, _excluded43);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-control"
  }, rest), children);
};

S.ProgressIcon = function (_ref44) {
  var children = _ref44.children,
      rest = _objectWithoutPropertiesLoose(_ref44, _excluded44);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-icon"
  }, rest), children);
};

S.ProgressIconStyle = function (_ref45) {
  var children = _ref45.children,
      rest = _objectWithoutPropertiesLoose(_ref45, _excluded45);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-icon-style"
  }, rest), children);
};

S.ProgressSpeed = function (_ref46) {
  var children = _ref46.children,
      rest = _objectWithoutPropertiesLoose(_ref46, _excluded46);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-speed"
  }, rest), children);
};

S.ProgressSpeedText = function (_ref47) {
  var children = _ref47.children,
      rest = _objectWithoutPropertiesLoose(_ref47, _excluded47);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "progress-speed-text"
  }, rest), children);
};

S.ProgressSpeedButton = function (_ref48) {
  var children = _ref48.children,
      active = _ref48.active,
      rest = _objectWithoutPropertiesLoose(_ref48, _excluded48);

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    className: "progress-speed-text-button " + (active ? "progress-speed-text-button-active" : "")
  }, rest), children);
}; // ---------------------------
// Transcript
// ---------------------------
// S.Transcript = styled.article`
//   font-family: ${DEFAULT_FONT};
//   font-size: 14px;
//   line-height: 1.5;
//   padding: 4px;
//   overflow-y: scroll;
//   flex: 1;
// `;


S.Transcript = function (_ref49) {
  var children = _ref49.children,
      rest = _objectWithoutPropertiesLoose(_ref49, _excluded49);

  return /*#__PURE__*/_react["default"].createElement("article", _extends({
    ref: rest.ref,
    className: "transcript-data"
  }, rest), children);
};

S.TranscriptBody = function (_ref50) {
  var children = _ref50.children,
      isChatTextMedia = _ref50.isChatTextMedia,
      rest = _objectWithoutPropertiesLoose(_ref50, _excluded50);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "transcript-body"
  }, rest), children);
};

S.TranscriptWord = function (_ref51) {
  var children = _ref51.children,
      rest = _objectWithoutPropertiesLoose(_ref51, _excluded51);

  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "transcript-word"
  }, rest), children);
};

S.TranscriptTitle = function (_ref52) {
  var children = _ref52.children,
      rest = _objectWithoutPropertiesLoose(_ref52, _excluded52);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "transcript-tile"
  }, rest), children);
}; // old


S.TranscriptTurn = function (_ref53) {
  var children = _ref53.children,
      className = _ref53.className,
      rest = _objectWithoutPropertiesLoose(_ref53, _excluded53);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "transcript-turn " + className,
    style: {
      marginLeft: function marginLeft(_ref54) {
        var marginOffset = _ref54.marginOffset;
        return marginOffset ? 0 : 0;
      }
    }
  }, rest), children);
};

S.TurnBody = function (_ref55) {
  var children = _ref55.children,
      rest = _objectWithoutPropertiesLoose(_ref55, _excluded54);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "turn-body"
  }, rest), children);
};

S.TurnHeader = function (_ref56) {
  var children = _ref56.children,
      rest = _objectWithoutPropertiesLoose(_ref56, _excluded55);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "turn-header"
  }, rest), children);
};

S.TurnLabels = function (_ref57) {
  var children = _ref57.children,
      rest = _objectWithoutPropertiesLoose(_ref57, _excluded56);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "turn-labels"
  }, rest), children);
};

S.TurnTime = function (_ref58) {
  var children = _ref58.children,
      rest = _objectWithoutPropertiesLoose(_ref58, _excluded57);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "turn-time"
  }, rest), children);
};

S.TimeLink = function (_ref59) {
  var children = _ref59.children,
      rest = _objectWithoutPropertiesLoose(_ref59, _excluded58);

  return /*#__PURE__*/_react["default"].createElement("a", _extends({
    className: "time-link"
  }, rest), children);
};

S.TurnSpeaker = function (_ref60) {
  var children = _ref60.children,
      rest = _objectWithoutPropertiesLoose(_ref60, _excluded59);

  return /*#__PURE__*/_react["default"].createElement("a", _extends({
    className: "turn-speaker-text",
    style: {
      color: rest.color
    }
  }, rest), children);
};

S.SentenceMarker = function (_ref61) {
  var children = _ref61.children,
      className = _ref61.className,
      rest = _objectWithoutPropertiesLoose(_ref61, _excluded60);

  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "turn-speaker " + className
  }, rest), children);
};

S.TurnSpeakerIcon = function (_ref62) {
  var children = _ref62.children,
      rest = _objectWithoutPropertiesLoose(_ref62, _excluded61);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "turn-speaker-icon"
  }, rest), children);
}; // ---------------------------
// Categories
// ---------------------------


S.Category = function (_ref63) {
  var children = _ref63.children,
      rest = _objectWithoutPropertiesLoose(_ref63, _excluded62);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "turn-speaker"
  }, rest), children);
};

S.CategoryIcon = function (_ref64) {
  var children = _ref64.children,
      rest = _objectWithoutPropertiesLoose(_ref64, _excluded63);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "category-icon",
    style: {
      background: function background(props) {
        return props.active ? "#0079C0" : "none";
      }
    }
  }, rest), children);
};

S.CategoryLabel = function (_ref65) {
  var children = _ref65.children,
      rest = _objectWithoutPropertiesLoose(_ref65, _excluded64);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "category-label"
  }, rest), children);
};

S.CategoryPill = function (_ref66) {
  var children = _ref66.children,
      rest = _objectWithoutPropertiesLoose(_ref66, _excluded65);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "category-pill",
    style: {
      background: rest.active ? "#0079C0" : "#fff",
      border: rest.active ? "1px #0079C0 solid" : "1px #0079C0 dashed",
      color: rest.active ? "#fff" : "#0079C0"
    }
  }, rest), children);
}; // ---------------------------
// Metrics
// ---------------------------
// ---------------------------
// List
// ---------------------------


S.List = function (_ref67) {
  var children = _ref67.children,
      rest = _objectWithoutPropertiesLoose(_ref67, _excluded66);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list"
  }, rest), children);
};

S.ListSectionContent = function (_ref68) {
  var children = _ref68.children,
      rest = _objectWithoutPropertiesLoose(_ref68, _excluded67);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-selection-content"
  }, rest), children);
};

S.ListSectionTitle = function (_ref69) {
  var children = _ref69.children,
      rest = _objectWithoutPropertiesLoose(_ref69, _excluded68);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-selection-title"
  }, rest), children);
};

S.ListSectionNoData = function (_ref70) {
  var children = _ref70.children,
      rest = _objectWithoutPropertiesLoose(_ref70, _excluded69);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-selection-no-data"
  }, rest), children);
};

S.ListSectionIcon = function (_ref71) {
  var children = _ref71.children,
      rest = _objectWithoutPropertiesLoose(_ref71, _excluded70);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-selection-icon"
  }, rest), children);
};

S.ListGroupHeader = function (_ref72) {
  var children = _ref72.children,
      rest = _objectWithoutPropertiesLoose(_ref72, _excluded71);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-group-header"
  }, rest), children);
};

S.ListGroupTitle = function (_ref73) {
  var children = _ref73.children,
      rest = _objectWithoutPropertiesLoose(_ref73, _excluded72);

  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "list-group-title"
  }, rest), children);
};

S.ListGroupMarker = function (_ref74) {
  var children = _ref74.children,
      rest = _objectWithoutPropertiesLoose(_ref74, _excluded73);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-group-marker",
    style: {
      visibility: function visibility(props) {
        return props.hide ? "hidden" : "visible";
      }
    }
  }, rest), children);
};

S.ListGroupMark = function (_ref75) {
  var children = _ref75.children,
      rest = _objectWithoutPropertiesLoose(_ref75, _excluded74);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-group-mark"
  }, rest), children);
};

S.ListGroupBody = function (_ref76) {
  var children = _ref76.children,
      collapsed = _ref76.collapsed,
      rest = _objectWithoutPropertiesLoose(_ref76, _excluded75);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-group-body"
  }, rest), !collapsed && children);
};

S.ListItem = function (_ref77) {
  var children = _ref77.children,
      rest = _objectWithoutPropertiesLoose(_ref77, _excluded76);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-item"
  }, rest), children);
};

S.ListItemContent = function (_ref78) {
  var children = _ref78.children,
      rest = _objectWithoutPropertiesLoose(_ref78, _excluded77);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-item-content",
    style: {
      //   background: rest.selected && "rgba(93, 44, 143, 0.2)",
      color: rest.selected && "#339EEC",
      fontWeight: rest.selected && "500"
    }
  }, rest), children);
};

S.ListItemExtra = function (_ref79) {
  var children = _ref79.children,
      rest = _objectWithoutPropertiesLoose(_ref79, _excluded78);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-item-extra"
  }, rest), children);
};

S.ListItemTitle = function (_ref80) {
  var children = _ref80.children,
      rest = _objectWithoutPropertiesLoose(_ref80, _excluded79);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-item-title-container",
    style: {
      color: rest.selected ? "#339EEC !important" : "#677791"
    }
  }, rest), children);
};

S.ListItemBadge = function (_ref81) {
  var children = _ref81.children,
      rest = _objectWithoutPropertiesLoose(_ref81, _excluded80);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-item-badge"
  }, rest), children);
};

S.ListGroup = function (_ref82) {
  var children = _ref82.children,
      rest = _objectWithoutPropertiesLoose(_ref82, _excluded81);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "list-group"
  }, rest), children);
};

S.ListCheckbox = function (_ref83) {
  var children = _ref83.children,
      rest = _objectWithoutPropertiesLoose(_ref83, _excluded82);

  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], _extends({
    className: "list-checkbox"
  }, rest), children);
};

S.TooltipContent = function (_ref84) {
  var children = _ref84.children,
      rest = _objectWithoutPropertiesLoose(_ref84, _excluded83);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "tooltip-content"
  }, rest), children);
};

S.SentimentButton = function (_ref85) {
  var children = _ref85.children,
      rest = _objectWithoutPropertiesLoose(_ref85, _excluded84);

  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "sentiment-button"
  }, rest), children);
};

S.FlagCallContent = function (_ref86) {
  var children = _ref86.children,
      rest = _objectWithoutPropertiesLoose(_ref86, _excluded85);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "flag-call"
  }, rest), children);
};

S.FlagCallImage = function (_ref87) {
  var children = _ref87.children,
      rest = _objectWithoutPropertiesLoose(_ref87, _excluded86);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "flag-call-image"
  }, rest), children);
};

S.FlagCallText = function (_ref88) {
  var children = _ref88.children,
      rest = _objectWithoutPropertiesLoose(_ref88, _excluded87);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "flag-call-text"
  }, rest), children);
};

S.FlagCallButton = function (_ref89) {
  var children = _ref89.children,
      rest = _objectWithoutPropertiesLoose(_ref89, _excluded88);

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    className: "flag-call-button",
    size: "sm"
  }, rest), children);
};

S.FlagCallButtonContent = function (_ref90) {
  var children = _ref90.children,
      rest = _objectWithoutPropertiesLoose(_ref90, _excluded89);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "flag-call-button-content"
  }, rest), children);
};

S.PrimaryControlTitle = function (_ref91) {
  var children = _ref91.children,
      rest = _objectWithoutPropertiesLoose(_ref91, _excluded90);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "primary-control-title"
  }, rest), children);
};

S.PrimaryControlSubTitle = function (_ref92) {
  var children = _ref92.children,
      rest = _objectWithoutPropertiesLoose(_ref92, _excluded91);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "primary-control-sub-title"
  }, rest), children);
};

S.ContentTitle = function (_ref93) {
  var children = _ref93.children,
      rest = _objectWithoutPropertiesLoose(_ref93, _excluded92);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "flag-title"
  }, rest), children);
};

S.MinimizeContent = function (_ref94) {
  var children = _ref94.children,
      rest = _objectWithoutPropertiesLoose(_ref94, _excluded93);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "minimize-content"
  }, rest), children);
};

S.MiniPlayerContainer = function (_ref95) {
  var children = _ref95.children,
      rest = _objectWithoutPropertiesLoose(_ref95, _excluded94);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "mini-player-container"
  }, rest), children);
};

S.MiniPlayerBody = function (_ref96) {
  var children = _ref96.children,
      rest = _objectWithoutPropertiesLoose(_ref96, _excluded95);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "mini-player-body"
  }, rest), children);
};

S.MiniPlayerControlBar = function (_ref97) {
  var children = _ref97.children,
      rest = _objectWithoutPropertiesLoose(_ref97, _excluded96);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "mini-player-control-bar"
  }, rest), children);
};

S.SearchContainer = function (_ref98) {
  var children = _ref98.children,
      rest = _objectWithoutPropertiesLoose(_ref98, _excluded97);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "search-container"
  }, rest), children);
};

S.SearchInput = function (_ref99) {
  var children = _ref99.children,
      rest = _objectWithoutPropertiesLoose(_ref99, _excluded98);

  return /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "search-input",
    type: "text"
  }, rest), children);
};

var _default = S;
exports["default"] = _default;